<script>
  import ImagePreviewModel from "../../../../Badge/Pages/FinalPage/Components/imagePreviewModel.svelte"

  /**
   * @type {import("../../../Script/document".bulkDocument)}
   */
  export let docData

  let showImage = false
</script>

<!-- {#each Object.entries(docData) as [key, value], i} -->
{#if !docData.upload}
  <!-- style="background:#F9E0C2;color: #EA9633" -->
  <div class="flex w-full items-center gap-3 rounded-md px-3 py-0.5">
    <div class="flex items-center text-yellow-600">
      <i class="fa-solid fa-triangle-exclamation" />
    </div>
    <h1 title={docData.name} class="truncate text-sm font-medium text-gray-200">
      {docData.name}
    </h1>
  </div>
{:else}
  <!-- style="background:#C2FFE9;" -->
  <div class="flex w-full items-center justify-between rounded-md px-3 py-0.5">
    <div class="flex items-center gap-3 truncate">
      <div class="flex items-center text-green-600">
        <i class="fa-solid fa-circle-check" />
      </div>
      <h1 title={docData.name} class="truncate text-sm font-medium text-gray-200">
        {docData.name}
      </h1>
    </div>
    <button on:click={() => (showImage = true)} class="flex max-w-[30%] items-center gap-3 text-sm font-medium text-blue-500 hover:text-blue-600">
      <i class="fa-solid fa-eye" />
      <span class="hidden md:block">Preview</span>
    </button>
    {#if showImage}
      <ImagePreviewModel link={docData.image.src} on:click={() => (showImage = false)} />
      <!-- <button on:click|self={() => (showImage = false)} class="fixed inset-0 z-30 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] p-6 backdrop-blur-md">
        <img src={docData.image.src} class="aspect-auto max-h-full cursor-auto rounded-sm" alt="dynamic file" />
      </button> -->
    {/if}
  </div>
  <!-- {/if} -->
{/if}
<!-- {/each} -->
